import React from 'react';

// styles
import { Spacing, Colors } from '_styles';

// task colors
import * as TaskColors from '../../timeline/utils/colors';

// icons
import { MdFlight, MdAirplanemodeActive } from 'react-icons/md';

const FlightRouteDisplay = ({ flightNumber, departure, arrival, flightType }) => {
    // Set background color based on flight type (same logic as card-bottom.js)
    let backgroundColor;
    if (flightType?.toLowerCase() === 'boarding') {
        backgroundColor = TaskColors.combinedBooking; // '#e895a4' - pinkish color for boarding
    } else if (flightType?.toLowerCase() === 'departure') {
        backgroundColor = Colors.PRM_LIGHT_BLUE; // blue for departures
    } else {
        backgroundColor = Colors.ARRIVALS_GREEN; // '#29C40D' - green for arrivals
    }

    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            gap: Spacing.SCALE_12,
            padding: Spacing.SCALE_12,
            backgroundColor,
            borderRadius: '8px',
            marginBottom: Spacing.SCALE_16
        }}>

            {/* Flight Number */}
            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: Spacing.SCALE_8,
                color: 'white',
                fontSize: 16,
                fontWeight: 600,
            }}>
                <span>{flightNumber || 'N/A'}</span>
            </div>

            {/* Departure */}
            <div style={{
                color: 'white',
                fontSize: 14,
                fontWeight: 500,
                textAlign: 'center',
                marginLeft: Spacing.SCALE_16,
            }}>
                <div style={{ fontSize: 16, fontWeight: 600 }}>{departure || 'N/A'}</div>
            </div>

            {/* Plane Icon */}
            <div style={{
                color: 'white',
                fontSize: 20,
                // rotate 90 degrees
                transform: 'rotate(90deg)',
            }}>
                <MdAirplanemodeActive size={20} />
            </div>

            {/* Arrival */}
            <div style={{
                color: 'white',
                fontSize: 14,
                fontWeight: 500,
                textAlign: 'center'
            }}>
                <div style={{ fontSize: 16, fontWeight: 600 }}>{arrival || 'N/A'}</div>
            </div>
        </div>
    );
};

export default FlightRouteDisplay;